import Face from "./Face";
import Edge from "./Edge";

export class RoomCeiling extends Face {
  constructor(sides: Edge[]) {
    super("room_ceiling", sides);
  }
}
